module.exports = __webpack_public_path__ + "assets/dac34e42d37bf72fb2d72587b443dd73.mp4";